import React from 'react';
import {Page} from '../../types';
import {Link} from '../../components';

type MenuItem =
  | {title: string; link: Page}
  // Plain anchor — external URLs, mailto:, etc. (not an internal Page route).
  | {title: string; href: string}
  | {title: string; onClick: () => void}
  // Non-interactive row
  | {title: string; muted: true};

export const DropdownMenu = ({
  menuItems,
  pastTop = true,
  align = 'left',
  bgClassName,
}: {
  menuItems: MenuItem[];
  pastTop?: boolean;
  align?: 'left' | 'right';
  // Overrides the default pastTop-based background — e.g. to match a
  // header that isn't the scroll-fading marketing NavHeader.
  bgClassName?: string;
}) => {
  return (
    <div
      className={`absolute top-full w-max pt-2 ${align === 'right' ? 'right-0' : 'left-0'}`}>
      <ul
        className={`list-none min-w-[10rem] rounded-2xl shadow-sm py-2 z-50 ${
          bgClassName ??
          (pastTop ? 'bg-background' : 'bg-background/70 backdrop-blur-md')
        }`}>
        {menuItems.map((item, i) => {
          return (
            <li key={i} className="text-smallbodymob">
              {'link' in item ? (
                <Link
                  className="block px-4 py-2 text-black hover:underline"
                  linkTo={item.link}>
                  {item.title}
                </Link>
              ) : 'href' in item ? (
                <a
                  href={item.href}
                  className="block px-4 py-2 text-black hover:underline">
                  {item.title}
                </a>
              ) : 'onClick' in item ? (
                <button
                  type="button"
                  onClick={item.onClick}
                  className="block w-full px-4 py-2 text-left text-black hover:underline">
                  {item.title}
                </button>
              ) : (
                <span className="mt-1 block truncate border-t border-divider px-4 pt-2 text-caption text-weak">
                  {item.title}
                </span>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
};
